import type { IKpiRepository } from '../repositories/IKpiRepository.js';

export function createDeleteKpiValueUseCase({ kpiRepository }: { kpiRepository: IKpiRepository }) {
  return (id: string): Promise<void> => kpiRepository.deleteKpiValue(id);
}
